import _ from 'lodash'
import { UUID } from '@/plugins/common'

export default class Group {
  constructor (args = {}) {
    const defaults = {
      id: UUID.create(),
      columnId: '',
      reportId: ''
    }
    _.defaults(this, args, defaults)
  }
}



// WEBPACK FOOTER //
// ./src/store/report/group.js